import React, { useEffect } from 'react';
import { Loader } from '../../../../components/Loader';
import { NoAccess } from '../../../../components/NoAccess';
import { useUnsafeTranslation } from '../../../../i18next';
import { useRoutes } from '../../../../routes';
import { useCurrentUser } from '../../../../services/currentUser';
import { getEmptyExperienceDraft } from '../../../../services/experiences/template';
import { setDoc } from '../../../../services/firebase';
import { hasPermissionToAccessPage } from '../../../../services/permissions';

export const Body = () => {
  const { id, org, email } = useCurrentUser();
  const { goTo, ROUTES } = useRoutes();
  useEffect(() => {
    const draft = getEmptyExperienceDraft(
      org.id,
      id,
      email,
      org.tz,
      org.defaultExperienceStartHour,
      org.sso.enabledForEndUsers
    );
    console.log(org);
    setDoc(draft)
      .then((d) => {
        goTo(ROUTES.experiences.details.edit.url(d.id));
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Loader />;
};

export const PageExperienceTemplateCreate = () => {
  const currentUser = useCurrentUser();
  const { ROUTES } = useRoutes();
  const { t } = useUnsafeTranslation();
  if (
    !hasPermissionToAccessPage(currentUser, ROUTES.experiences.details.create)
  ) {
    return (
      <NoAccess
        title={t('You can’t create new experiences')}
        action={t('creating new experience')}
        buttonLabel={t('Go to Experiences List')}
        buttonLink={ROUTES.experiences.overview.url()}
      />
    );
  }

  return <Body />;
};
